import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import login from '../views/login.vue'
import resetPassword from '../views/resetPassword.vue'
import unauth from '../views/403.vue'
import empty from '../views/404.vue'

// hotels
import hotels from '../views/hotels/hotels.vue'
import hotel from '../views/hotels/hotel.vue'
import hotelPolicies from '../views/hotels/hotelPolicies.vue'
import addHotel from '../views/hotels/addHotel.vue'
import seasons from '../views/hotels/seasons.vue'
import hotelsBookings from '../views/hotels/hotelsBookings.vue'
import hotelBooking from '../views/hotels/hotelBooking.vue'

// activities
import activities from '../views/activities/activities.vue'
import adventuresBookings from '../views/activities/adventuresBookings.vue'
import activityBooking from '../views/activities/activityBooking.vue'

// cruises
import cruises from '../views/cruises/list.vue'
import addCruise from '../views/cruises/form.vue'
// import storeCruise from '../views/cruises/form.vue'
import cruise from '../views/cruises/cruise.vue'
import cruisesBookings from '../views/cruises/cruisesBookings.vue'
import cruiseBooking from '../views/cruises/cruiseBooking.vue'

// trips
import tripsCities from '../views/trips/cities.vue'
import tripsTours from '../views/trips/tours.vue'
import tour from '../views/trips/tour.vue'
import tripBookings from '../views/trips/packageBookings.vue'
import packageBooking from '../views/trips/packageBooking.vue'
import addPackage from '../views/trips/addPackage.vue'
import editPackage from '../views/trips/editPackage.vue'

// settings
import settingSeo from '../views/settings/seo.vue'
import FeeSettings from '../views/settings/FeeSettings.vue'
import AppContent from '../views/settings/AppContent.vue'
import AppPages from '../views/settings/AppPages.vue'

// users
import registeredUsers from '../views/registeredUsers.vue'
import notifications from '../views/notifications.vue'
import HotelRefunds from '../views/refunds/Refunds.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true, title: 'Dashboard', section: 'Overview', nav: 'Home' }
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: { layout: 'auth', title: 'Sign in' }
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: resetPassword,
    meta: { layout: 'auth', title: 'Reset password' }
  },
  {
    path: '/registeredUsers',
    name: 'registeredUsers',
    component: registeredUsers,
    meta: { requiresAuth: true, title: 'Registered Users', section: 'Customers', nav: 'registeredUsers' }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: notifications,
    meta: { requiresAuth: true, title: 'Notifications', section: 'Customers', nav: 'notifications' }
  },
  {
    path: '/hotel-refunds',
    name: 'hotelRefunds',
    component: HotelRefunds,
    meta: { requiresAuth: true, title: 'Refunds', section: 'Bookings', nav: 'hotelRefunds' }
  },
  // hotels
  {
    path: '/hotels',
    name: 'hotels',
    component: hotels,
    meta: { requiresAuth: true, title: 'Hotels', section: 'Catalog', nav: 'hotels' }
  },
  {
    path: '/hotel/:id',
    name: 'hotel',
    component: hotel,
    meta: { requiresAuth: true, title: 'Hotel details', section: 'Catalog', parent: 'hotels', nav: 'hotels' }
  },
  {
    path: '/add-hotel',
    name: 'addHotel',
    component: addHotel,
    meta: { requiresAuth: true, title: 'New hotel', section: 'Catalog', parent: 'hotels', nav: 'hotels' }
  },
  {
    path: '/hotels/bookings',
    name: 'hotelsBookings',
    component: hotelsBookings,
    meta: { requiresAuth: true, title: 'Hotel Bookings', section: 'Bookings', nav: 'hotelsBookings' }
  },
  {
    path: '/hotel/booking/:id',
    name: 'hotelBooking',
    component: hotelBooking,
    meta: { requiresAuth: true, title: 'Hotel booking', section: 'Bookings', parent: 'hotelsBookings', nav: 'hotelsBookings' }
  },
  {
    path: '/children-policies/:type/:id/:occupancy',
    name: 'hotelPolicies',
    component: hotelPolicies,
    meta: { requiresAuth: true, title: 'Children policies', section: 'Catalog', parent: 'hotels', nav: 'hotels' }
  },
  {
    path: '/seasons',
    name: 'seasons',
    component: seasons,
    meta: { requiresAuth: true, title: 'Hotel Seasons', section: 'Catalog', nav: 'seasons' }
  },

  // activities
  {
    path: '/activities',
    name: 'activities',
    component: activities,
    meta: { requiresAuth: true, title: 'Adventures', section: 'Catalog', nav: 'activities' }
  },
  {
    path: '/adventures/bookings',
    name: 'adventuresBookings',
    component: adventuresBookings,
    meta: { requiresAuth: true, title: 'Adventure Bookings', section: 'Bookings', nav: 'adventuresBookings' }
  },
  {
    path: '/activity/booking/:id',
    name: 'activityBooking',
    component: activityBooking,
    meta: { requiresAuth: true, title: 'Adventure booking', section: 'Bookings', parent: 'adventuresBookings', nav: 'adventuresBookings' }
  },

  // tours
  {
    path: '/trip-cities',
    name: 'tripsCities',
    component: tripsCities,
    meta: { requiresAuth: true, title: 'Trip Cities', section: 'Catalog', nav: 'tripsCities' }
  },
  {
    path: '/trip-tours',
    name: 'tripsTours',
    component: tripsTours,
    meta: { requiresAuth: true, title: 'Packages', section: 'Catalog', nav: 'tripsTours' }
  },
  {
    path: '/trip-tour/:id',
    name: 'tour',
    component: tour,
    meta: { requiresAuth: true, title: 'Package details', section: 'Catalog', parent: 'tripsTours', nav: 'tripsTours' }
  },
  {
    path: '/add-package',
    name: 'addPackage',
    component: addPackage,
    meta: { requiresAuth: true, title: 'New package', section: 'Catalog', parent: 'tripsTours', nav: 'tripsTours' }
  },
  {
    path: '/edit-package',
    name: 'editPackage',
    component: editPackage,
    meta: { requiresAuth: true, title: 'Edit package', section: 'Catalog', parent: 'tripsTours', nav: 'tripsTours' }
  },
  // {
  //   path: '/adventures/bookings',
  //   name: 'adventuresBookings',
  //   component: adventuresBookings
  // },
  {
    path: '/package/bookings',
    name: 'tripBookings',
    component: tripBookings,
    meta: { requiresAuth: true, title: 'Package Bookings', section: 'Bookings', nav: 'tripBookings' }
  },
  {
    path: '/package/booking/:id',
    name: 'packageBooking',
    component: packageBooking,
    meta: { requiresAuth: true, title: 'Package booking', section: 'Bookings', parent: 'tripBookings', nav: 'tripBookings' }
  },
  {
    path: '/cruises',
    name: 'cruises',
    component: cruises,
    meta: { requiresAuth: true, title: 'Cruises', section: 'Catalog', nav: 'cruises' }
  },
  {
    path: '/cruises/add',
    name: 'addCruise',
    component: addCruise,
    meta: { requiresAuth: true, title: 'New cruise', section: 'Catalog', parent: 'cruises', nav: 'cruises' }
  },
  {
    path: '/cruise/:id',
    name: 'cruise',
    component: cruise,
    meta: { requiresAuth: true, title: 'Cruise details', section: 'Catalog', parent: 'cruises', nav: 'cruises' }
  },
  {
    path: '/cruises/bookings',
    name: 'cruisesBookings',
    component: cruisesBookings,
    meta: { requiresAuth: true, title: 'Cruise Bookings', section: 'Bookings', nav: 'cruisesBookings' }
  },
  {
    path: '/cruise/booking/:id',
    name: 'cruiseBooking',
    component: cruiseBooking,
    meta: { requiresAuth: true, title: 'Cruise booking', section: 'Bookings', parent: 'cruisesBookings', nav: 'cruisesBookings' }
  },

  // Settings
  {
    path: '/setting-seo',
    name: 'settingSeo',
    component: settingSeo,
    meta: { requiresAuth: true, title: 'SEO', section: 'Settings', nav: 'settingSeo' }
  },
  {
    path: '/setting-fees',
    name: 'settingFees',
    component: FeeSettings,
    meta: { requiresAuth: true, title: 'Fee Settings', section: 'Settings', nav: 'settingFees' }
  },
  {
    path: '/app-content',
    name: 'appContent',
    component: AppContent,
    meta: { requiresAuth: true, title: 'App content', section: 'Settings', nav: 'appContent' }
  },
  {
    path: '/app-pages',
    name: 'appPages',
    component: AppPages,
    meta: { requiresAuth: true, title: 'App pages', section: 'Settings', nav: 'appPages' }
  },

  // error pages
  {
    path: '/unauth',
    name: 'unauth',
    component: unauth,
    meta: { title: 'Access denied' }
  },
  {
    path: '*',
    name: '404',
    component: empty,
    meta: { title: 'Page not found' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach(to => {
  const title = to.meta && to.meta.title
  document.title = title ? `${title} · Tanefer Admin` : 'Tanefer Admin'
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  let isAuthenticated = false
  // const getCookie = this.$cookies.get('userToken')
  // console.log(token)
  if (token) {
    const decodedToken = JSON.parse(atob(token.split('.')[1])) // Decode the token
    // Get the expiration time (in seconds)
    const expirationTime = decodedToken.exp
    // Get the current time (in seconds)
    const currentTime = Math.floor(Date.now() / 1000)
    isAuthenticated = token && currentTime < expirationTime
  } else {
    isAuthenticated = token && currentTime < expirationTime
  }
  // Check if the token is expired
  // return currentTime > expirationTime;
  // console.log(currentTime < expirationTime, currentTime, expirationTime)
  // let isAuthenticated = false
  // if (token && currentTime < expirationTime) {
  //   isAuthenticated = true
  // } else {
  //   isAuthenticated = false
  // }
  // const isAuthenticated = token && currentTime < expirationTime
  // console.log(isAuthenticated, currentTime, expirationTime)
  // console.log(to)
  // console.log(to.name === 'login' && isAuthenticated)
  // console.log(to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated, to.matched.some(record => record.name), to.matched.some(record => record.meta.requiresAuth), !isAuthenticated)
  // console.log(to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated)
  // if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
  //   next({
  //     name: 'login', // Redirect to the login page if not authenticated
  //     query: { redirect: to.fullPath } // Optionally pass the original path as a query parameter
  //   })
  // } else if (to.name === 'login' && isAuthenticated) {
  //   next({ name: 'Home' })
  //   // next()
  // } else {
  //   next() // Continue with the navigation
  // }

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next({
      name: 'login', // Redirect to the login page if not authenticated
      query: { redirect: to.fullPath } // Optionally pass the original path as a query parameter
    })
  } else {
    next() // Continue with the navigation
  }
})

export default router
